import { cn } from "@/lib/utils";

export const LogoMark = ({ className }) => (
    <svg viewBox="0 0 48 48" className={cn("h-9 w-9", className)} aria-hidden="true" data-testid="logo-mark">
        <rect width="48" height="48" rx="11" fill="#0F4C3A" />
        <path
            d="M19.5 13v22 M8.5 24h11 M19.5 24l4.5-7.5 4.5 15 4.5-7.5h6.5"
            stroke="#FBFBF9"
            strokeWidth="3.4"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const Logo = ({ className }) => (
    <span className={cn("inline-flex items-center gap-2.5", className)} data-testid="logo">
        <LogoMark />
        <span className="font-heading text-xl font-bold tracking-tight text-foreground">
            Hallo<span className="text-primary dark:text-teal">medics</span>
        </span>
    </span>
);

export const PlusSeparator = ({ className }) => (
    <svg viewBox="0 0 24 24" className={cn("h-4 w-4 text-terracotta", className)} fill="none" aria-hidden="true">
        <path d="M12 4v16M4 12h16" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
);
